export const equalArrays = <T>(a1: T[], a2: T[]) => a1.length === a2.length && a1.every((e, i) => e === a2[i])
